import Helmet from "react-helmet";

export const DynamicMetaTags = ({
  ogTitle,
  ogImage,
  ogUrl,
  ogDescription,
  ogType = "website",
  publishedTime,
}) => {
  return (
    <Helmet>
      <title>{ogTitle}</title>
      <meta name="title" content={ogTitle} />
      <meta name="description" content={ogDescription} />
      <link rel="canonical" href={`https://${ogUrl}`} />
      {/* Facebook & Linkedin Meta Tags */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={`https://${ogUrl}`} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:image" content={ogImage} />
      {publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      <link rel={"shortcut icon"} href={ogImage} />
      {/* Twitter Meta Tags  */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={`https://${ogUrl}`} />
      <meta property="twitter:title" content={ogTitle} />
      <meta property="twitter:description" content={ogDescription} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
};
